import {
  StudentActivityResponse,
  isMultipleChoiceResponse,
  isTrueFalseResponse,
} from '~teacher/models/activities';
import { QuizAnswer } from '~teacher/models/quizzes';

export interface AnswerData {
  numberResponses: number;
}

export interface AggregateAnswerData {
  totalSingleResponses: number;
  answerData: Record<string, AnswerData>;
}

export const calculateAggregateAnswerData = (
  answers: QuizAnswer[],
  responses: StudentActivityResponse[]
): AggregateAnswerData => {
  let totalSingleResponses = 0;

  const answerData: Record<string, AnswerData> = answers.reduce(
    (accumulator, answer) => {
      const emptyData = { numberResponses: 0 };
      return { ...accumulator, [answer.id]: emptyData };
    },
    {}
  );

  responses.forEach((response) => {
    if (isTrueFalseResponse(response)) {
      const answer = answerData[response.selectedAnswer];
      if (answer) {
        totalSingleResponses++;
        answerData[response.selectedAnswer].numberResponses++;
      }
    }

    if (isMultipleChoiceResponse(response)) {
      response.selectedAnswers.forEach((answerId) => {
        const answer = answerData[answerId];
        if (answer) {
          totalSingleResponses++;
          answerData[answerId].numberResponses++;
        }
      });
    }
  });

  return {
    totalSingleResponses,
    answerData,
  };
};
